/* eslint-disable import/no-extraneous-dependencies */
import { useState, useContext, useEffect } from 'react';
import merge from 'lodash.merge';
import _ from 'lodash';

import JobListContext from '../app/context/jobListContext';
import AppStateContext from "../app/context/appStateContext";
import filterHelper from "./useFilterHelper";
import moment from "moment";
import ReactiveJob from "../app/interfaces/reactiveJob";

const useReactiveFilterForm = () => {
  const { reactiveJobList, filtersReactive, updateFilteredReactiveJobList, updateReactiveFilters } = useContext(JobListContext);
  const { contractList, actionCodes, selectedCustomerId } = useContext(AppStateContext);

  const { getDatePeriod } = filterHelper();

  const initialiseFilter = (defaultState: {}, filter: [] | string) => {
    let newState;

    if(_.isArray(filter)) {
      newState = _.cloneDeep(defaultState);
      filter.map(filterCriteria => {
        newState[filterCriteria] = true;
      });
    } else {
      newState = filter;
    }

    return newState;
  };

  const initialiseBuilding = () => {
    let buildings = {};
    Object.keys(contractList[selectedCustomerId]).map((item,index) => {
      buildings[item] = false;
    });
    return buildings;
  };

  const initialiseActionCodes = () => {
    let actionTypes = {};
    actionCodes.map((action: {
      Action: string,
      ActionCode: string,
    }) => {
      actionTypes[action.Action] = false;
    });

    return actionTypes;
  };

  const [listedPeriodFilter, setListedPeriodFilter] = useState('');
  const [slaTabFilters, setSlaTabFilters] = useState(() => {return initialiseFilter({}, filtersReactive.slaFilters)});
  const [priorityTabFilters, setPriorityTabFilters] = useState(() => { return initialiseFilter({}, filtersReactive.priortiyFilters)});
  const [statusTabFilters, setStatusTabFilters] = useState(() => {return initialiseFilter({}, filtersReactive.statusFilters)});
  const [ buildingTabFilters, setBuildingTabFilters ] = useState({});
  const [ actionTabFilters, setActionTabFilters ] = useState({});
  const [ dateTabFilter, setDateTabFilter ] = useState( filtersReactive.dateFilter);

  useEffect(() => {
    setBuildingTabFilters(initialiseBuilding());
    setActionTabFilters(initialiseActionCodes());
  },[]);

  const handleSubmit = (event: any) => {
    if (event) {
      event.preventDefault();
    }

    const buildingList = _.keys(_.pickBy(buildingTabFilters));
    const actionList = _.keys(_.pickBy(actionTabFilters));
    const dateFilter = dateTabFilter;

    updateReactiveFilters({
      periodFilter: listedPeriodFilter,
      slaFilters: slaTabFilters,
      priortiyFilters: priorityTabFilters,
      statusFilters: statusTabFilters,
      buildingFilters: buildingList,
      actionFilters: actionList,
      dateFilter: dateFilter,
    });

    if (slaTabFilters != '' || priorityTabFilters != '' || statusTabFilters != '' || buildingList.length || actionList.length) {
      let allDate = true;

      updateFilteredReactiveJobList(
        reactiveJobList.filter((job: ReactiveJob) => {
          let finalBoolean = true;

          if(listedPeriodFilter !== '' || dateFilter != undefined && Object.keys(dateFilter).length) {
            allDate = (listedPeriodFilter != '' && moment(moment(job.ReceivedDatetime.split('+')[0], 'YYYY-MM-DDThh:mm:ss')).isBetween(getDatePeriod(listedPeriodFilter).startDate, getDatePeriod(listedPeriodFilter).endDate)
              || dateFilter && moment(job.ReceivedDatetime.split('+')[0], 'YYYY-MM-DDThh:mm:ss').isBetween(dateFilter.startDate, dateFilter.endDate))
          } else {
            allDate = true;
          }

          if(slaTabFilters != '') finalBoolean = finalBoolean && ( slaTabFilters == job.SLAOnsite ||
            job.SLAOnsite == 'missedDeadline' && slaTabFilters == 'onsiteMissedDeadline' ||
            job.SLAOnsite == 'doneOnTime' && slaTabFilters == 'onsiteDoneOnTime' ||
            job.SLAComplete == 'missedDeadline' && slaTabFilters == 'completionMissedDeadline' ||
            job.SLAComplete == 'doneOnTime' && slaTabFilters == 'completionDoneOnTime'
          );
          if(statusTabFilters != '') finalBoolean = finalBoolean && statusTabFilters == job.Status;
          if(priorityTabFilters != '') finalBoolean = finalBoolean && priorityTabFilters == job.PriorityCode.toString();
          if(buildingList.length) finalBoolean = finalBoolean && buildingList.includes(job.ContractNo);
          if(actionList.length ) finalBoolean = finalBoolean && actionList.includes(job.Action);

          return finalBoolean && allDate;
        })
      );
    } else if(listedPeriodFilter !== '' || Object.keys(dateFilter).length){
      updateFilteredReactiveJobList(
        reactiveJobList.filter(job => {
          // ADD MORE FILTER CRITERIAS
          return (listedPeriodFilter != '' && moment(moment(job.ReceivedDatetime.split('+')[0], 'YYYY-MM-DDThh:mm:ss')).isBetween(getDatePeriod(listedPeriodFilter).startDate, getDatePeriod(listedPeriodFilter).endDate)
            || dateFilter && moment(job.ReceivedDatetime.split('+')[0], 'YYYY-MM-DDThh:mm:ss').isBetween(dateFilter.startDate, dateFilter.endDate));
        })
      );
    } else {
      updateFilteredReactiveJobList(reactiveJobList);
    }
  };

  const handleBuildingChange = (element: string) => {
    setBuildingTabFilters(prevState => {
      const newState = {...prevState};

      let newBuilding = {};
      newBuilding[element] = !newState[element];

      return _.merge(newState, newBuilding);
    })
  };

  const handleActionChange = (action: string) => {
    setActionTabFilters(prevState => {
      const newState = {...prevState};

      let newAction = {};
      newAction[action] = !newState[action];

      return _.merge(newState,newAction);
    })
  };

  const handleListedPeriodChange = (event: any) => {
    event.persist();

    setDateTabFilter({});
    if(listedPeriodFilter == event.target.value) {
      setListedPeriodFilter('');
    }
    else {
      setListedPeriodFilter(event.target.value);
    }
  };

  const handleSlaChange = (event: any) => {
    event.persist();

    if(slaTabFilters == event.target.value) setSlaTabFilters('');
    else setSlaTabFilters(event.target.value);
  };

  const handlePriorityChange = (event: any) => {
    event.persist();

    if(priorityTabFilters == event.target.value) setPriorityTabFilters('');
    else setPriorityTabFilters(event.target.value);
  };

  const handleStatusChange = (event: any) => {
    event.persist();

    if(statusTabFilters == event.target.value) setStatusTabFilters('');
    else setStatusTabFilters(event.target.value);
  };

  const handleDateChange = (newDates: {startDate: any, endDate: any}) => {
    setDateTabFilter({startDate: newDates.startDate.startOf('day'), endDate: newDates.endDate.endOf('day')});
    setListedPeriodFilter('')
  };

  const clearAllFilters = (event: any) => {
    event.persist();
    setListedPeriodFilter('');
    setSlaTabFilters('');
    setPriorityTabFilters('');
    setStatusTabFilters('');
    setBuildingTabFilters(initialiseBuilding());
    setActionTabFilters(initialiseActionCodes());
    setDateTabFilter({});
  };

  return {
    listedPeriodFilter,
    slaTabFilters,
    priorityTabFilters,
    statusTabFilters,
    buildingTabFilters,
    actionTabFilters,
    dateTabFilter,
    handleSubmit,
    handleBuildingChange,
    handleActionChange,
    handleListedPeriodChange,
    handleSlaChange,
    handlePriorityChange,
    handleStatusChange,
    handleDateChange,
    clearAllFilters,
  };
};

export default useReactiveFilterForm;
